/** Browser RUM bootstrap loaded by Next.js before React mounts. */

import { initDatadogRum } from '@brew/observability/browser'
import { normalizeDatadogTag } from '@brew/observability/core'
import { installEarlyPopstateInterceptor } from './components/navigation/unsaved-changes-registry'

// Before the app router mounts its own popstate listener: a window runs its
// listeners in registration order, so only a listener registered first can
// stop Back / Forward from leaving a surface with unsaved edits.
installEarlyPopstateInterceptor()

const isProductionBuild = process.env.NODE_ENV === 'production'
const additionalTracingPrefixes =
  process.env.NEXT_PUBLIC_DATADOG_ALLOWED_TRACING_URLS?.split(',')
    .map((value) => value.trim())
    .filter(Boolean) ?? []

if (isProductionBuild) {
  initDatadogRum({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE,
    service: 'brew-web',
    env: normalizeDatadogTag(
      process.env.NEXT_PUBLIC_VERCEL_ENV ??
        process.env.NEXT_PUBLIC_DATADOG_ENV ??
        process.env.NODE_ENV,
      'development'
    ),
    version:
      process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ??
      process.env.NEXT_PUBLIC_DATADOG_VERSION,
    origin: window.location.origin,
    additionalTracingPrefixes,
    sessionSampleRate: process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE,
    replaySampleRate: process.env.NEXT_PUBLIC_DATADOG_REPLAY_SAMPLE_RATE,
    profilingSampleRate: process.env.NEXT_PUBLIC_DATADOG_PROFILING_SAMPLE_RATE,
  })
}

export { onRouterTransitionStart } from '@datadog/browser-rum-nextjs'
